/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      setTimeout(() => {
        const buttons = Array.from(this.querySelectorAll('button'));
        const sectionHeader = this.closest('.section-header');
        if (!sectionHeader) return;

        const links = sectionHeader.querySelectorAll('.linked-to-tab');
        this.target = this.dataset.target;
        this.slider = document.getElementById(this.target);

        buttons.forEach((button, i) => {
          button.addEventListener('click', (event) => {
            this.toggleButtons(buttons, i);
            this.toggleLinks(links, i);
            if (button.dataset.collection) {
              this.toggleCollection(button.dataset.collection);
            }
            event.preventDefault();
          });
        });

        window.addEventListener('resize', () => {
          if (!this.slider) return;
          if (this.slider.classList.contains('full-width-stacked-p')) return; // stacked mode skip
          let flkty = Flickity.data(this.slider);
          if (flkty) flkty.resize();
        });

        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            const index = buttons.indexOf(event.target);
            if (index !== -1) {
              buttons[index].dispatchEvent(new Event('click'));
            }
          });
        }
      }, 10);
    }

    toggleButtons(buttons, index) {
      buttons.forEach((button) => button.classList.remove('active'));
      buttons[index].classList.add('active');
    }

    toggleLinks(links, index) {
      if (links.length) {
        links.forEach((link) => link.classList.remove('active'));
        links[index].classList.add('active');
      }
    }

    toggleCollection(handle) {
      const target = document.getElementById(this.target);
      if (!target) return;

      // 🔹 Stacked mode (grid)
      if (target.classList.contains('full-width-stacked-p')) {
        const panels = target.querySelectorAll('.collection-tab-panel');
        panels.forEach(panel => {
          panel.removeAttribute('style'); // kill inline display:flex
          if (panel.dataset.collection === handle) {
            panel.classList.add('active');
          } else {
            panel.classList.remove('active');
          }
        });
        return;
      }

      // 🔹 Slider mode (Flickity)
      const products = target.querySelectorAll(`.columns:not([data-collection="${handle}"])`);
      const activeProducts = target.querySelectorAll(`[data-collection="${handle}"]`);
      const flkty = Flickity.data(target);

      products.forEach((product) => { 
        product.classList.remove('carousel__slide'); 
        target.append(product); 
      });
      activeProducts.forEach((product) => product.classList.add('carousel__slide'));

      if (flkty) {
        flkty.insert(activeProducts);
        flkty.reloadCells();
        flkty.select(0, 0, 1);
      }
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}
